import { defineStore } from 'pinia'
import { reactive, readonly, computed } from 'vue'

interface IMapStoreState {
	clickedLocation: any
	openTooltip: boolean
}

interface IMapStore {
	readonly state: IMapStoreState
	setClickedLocation: (location: any) => void
	setOpenTooltip: (openTooltip: boolean) => void
	getClickedLocation: ComputedRef<any>
	getOpenTooltip: ComputedRef<boolean>
}

export const useMapStore = defineStore('mapStore', (): IMapStore => {
	const _state = reactive<IMapStoreState>({
		clickedLocation: null,
		openTooltip: false,
	})

	const setClickedLocation = (location: any): void => {
		_state.clickedLocation = location
	}

	const setOpenTooltip = (openTooltip: boolean): void => {
		_state.openTooltip = openTooltip
	}

	const getClickedLocation = computed(() => _state.clickedLocation)

	const getOpenTooltip = computed(() => _state.openTooltip)

	return {
		state: readonly(_state),
		setClickedLocation,
		setOpenTooltip,
		getClickedLocation,
		getOpenTooltip,
	}
})
